const tableOfContentsList = document.querySelector('.c-links-list.table-of-contents');
if(tableOfContentsList) {
  function textToId(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '') // Remove special chars
      .replace(/\s+/g, '-') // Spaces to dashes
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
  }

  function getUniqueId(baseId, counts) {
    if (!counts[baseId]) {
      counts[baseId] = 1;
      return baseId;
    }

    counts[baseId] += 1;
    return `${baseId}-${counts[baseId]}`;
  }

  // GET MAIN CONTENT
  const postContent = document.querySelector('.c-richtext.main-content');
  if (postContent) {
    const headings = Array.from(postContent.querySelectorAll('h2, h3'));
    const tocLinks = Array.from(tableOfContentsList.querySelectorAll('a'));
    
    function syncAnchors() {
      const headingCounts = {};
      const tocCounts = {};

      headings.forEach(function (heading) {
        const existingId = heading.getAttribute('id');

        // Respect manually specified IDs
        if (existingId) return;

        const text = heading.textContent || heading.innerText || '';
        
        const baseId = textToId(text);
        if (!baseId) return;

        const id = getUniqueId(baseId, headingCounts);
        heading.setAttribute('id', id);
      });

      tocLinks.forEach(function (link) {
        const text = link.textContent || link.innerText || '';
        const baseId = textToId(text);
        if (!baseId) return;

        const id = getUniqueId(baseId, tocCounts);
        link.setAttribute('href', `#${id}`);
      });
    }

    syncAnchors();

    let debounceTimer;
    const observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncAnchors, 50);
    });

    headings.forEach(function (heading) {
      observer.observe(heading, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });

    tocLinks.forEach(function (link) {
      observer.observe(link, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    });
  }

}